'use client';
import Link from 'next/link';
import type { AnswerEntry } from '../lib/types';

export function DecodeReveal({ answer, solved, guesses }: {
  answer: AnswerEntry; solved: boolean; guesses: number;
}) {
  return (
    <div style={{ maxWidth: 560, margin: '20px auto', textAlign: 'center' }}>
      <h2>{solved ? `Solved in ${guesses}!` : 'Out of guesses'}</h2>
      <p style={{ fontSize: 18, fontWeight: 600 }}>The car was the {answer.label}.</p>
      <p style={{ color: 'var(--dc-ink-3)' }}>💡 {answer.fun_fact}</p>
      {/* cars_slug is the full "<variant>/<gen>" path, set in content.ts ONLY for
          cars whose exact generation has an editorial atom on /cars. No atom →
          no link (rather than a generic or 404 link). */}
      {answer.cars_slug && (
        <Link href={`/cars/${answer.cars_slug}`}>
          Read the full verdict on /cars →
        </Link>
      )}
    </div>
  );
}
